module.exports = new __parcel__URL__("battleroyale_join_bg.e1e2af1f.png").toString();